import gql from 'graphql-tag';

/**
 * 获取轮播数据
 */
export const fetchBannersDocument = gql`
  query banners($options: BannerListOptions) {
    banners(options: $options) {
      items {
        id
        image
        redirect
        redirectType
      }
      totalItems
    }
  }
`;

/**
 * 获取个人中心配置数据
 */
export const fetchPersonalCenterDocument = gql`
  query personalCenter {
    personalCenter {
      id
      topComponentType
      topComponent {
        backGroundImage {
          ...PictureResource
        }
        backGroundColor
        layoutType
        pictures {
          ...PictureResource
        }
        productGroup {
          menuCollection {
            menuName
            collectionId
          }
          groupType
        }
        productItems {
          showType
          ids
        }
        productCategoryList {
          banner {
            ...PictureResource
          }
          title
          subCategory {
            banner {
              ...PictureResource
            }
            title
          }
        }
        countdownEndTime
        backGroundColor
        fontColor
        borderColor
        borderInsideColor
      }
      bottomComponentType
      bottomComponent {
        backGroundImage {
          ...PictureResource
        }
        backGroundColor
        layoutType
        pictures {
          ...PictureResource
        }
        productGroup {
          menuCollection {
            menuName
            collectionId
          }
          groupType
        }
        productItems {
          showType
          ids
        }
        productCategoryList {
          banner {
            ...PictureResource
          }
          title
          subCategory {
            banner {
              ...PictureResource
            }
            title
          }
        }
        countdownEndTime
        backGroundColor
        fontColor
        borderColor
        borderInsideColor
      }
    }
  }
  fragment PictureResource on PictureResource {
    imgHeight
    imgWidth
    imgUrl
    videoUrl
    alt
    jump {
      ...Jump
    }
  }
  fragment Jump on Jump {
    startAxisX
    startAxisY
    endPointAxisX
    endPointAxisY
    jumpType
    jumpValue
    jumpName
  }
`;
